<template>
  <div id="page_not_found" class="flex-full">
    <section style="text-align: center" class="bg-cl-secondary py35 px20">
      <div class="container">
        <h2>
          {{ $t("Something went wrong ...") }}
        </h2>
      </div>
    </section>
    <section style="text-align: center" class="bg-cl-primary py35 px20">
      <div class="container">
        <div class="lh16 h5 weight-400">
          <p>
            {{ $t("We've noticed Internal Server Error while rendering this request.") }}
          </p>
          <p>
            <a href="/" class="cl-secondary no-underline">
              {{ $t('Go to Homepage') }}
            </a>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Error from '@vue-storefront/core/pages/Error'
import {Logger} from "@vue-storefront/core/lib/logger";
import moment from 'moment-timezone';

export default {
  name: 'Error',
  mixins: [Error],
  asyncData ({ store, route, context }) { // this is for SSR purposes to prefetch data
    return new Promise((resolve, reject) => {
      Logger.log('Calling asyncData for Error page ' + new Date(moment().tz('Europe/Kiev').format()))()
      if (context) {
        context.output.cacheTags.add(`error`)
        context.server.response.statusCode = 503
      }
      resolve()
    })
  },
}
</script>

<style scoped>
  a {
    text-decoration: underline;
  }
</style>
